import { Stack } from '@mui/material';
import { useOffersTrendsQuery } from 'api/reports-service/reports-service';
import JobsStatusGate from 'components/jobs-status-gate/jobs-status-gate.component';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import LoyaltyPerformanceHeader from 'components/loyalty-performance-header/loyalty-performance-header.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import { useLoyaltyOfferTrendsSearchParams } from '../loyalty-performance-report.hooks';
import LoyaltyOfferTrendsLineChart from './loyalty-offer-trends-line-chart/loyalty-offer-trends-line-chart.component';
import LoyaltyOfferTrendsAPIDetailsDrawer from 'components/drawers/loyalty-offer-trends-api-details-drawer/loyalty-offer-trends-api-details-drawer.component';
import { useTranslation } from 'react-i18next';
import {
  LoyaltyPerformanceParamsDiff,
  OfferTrendsParams,
} from 'api/reports-service/reports-service.types';
import TrendsDataGrid from 'pages/loyalty-performance-report/trends-data-grid/trends-data-grid.component';
import { useGetTrendsSearchResults } from 'pages/loyalty-performance-report/trends-data-grid/trends-data-grid.hooks';
import { getMaxColumns } from 'pages/loyalty-performance-report/trends-data-grid/trends-data-grid.utils';

const filteredSearchParams: LoyaltyPerformanceParamsDiff<OfferTrendsParams> = [
  'comparisonenddate',
  'comparisonstartdate',
  'sortBy',
  'sortDirection',
];

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(useLoyaltyOfferTrendsSearchParams());
  return (
    <SearchParamsProvider value={searchParams}>
      <LoyaltyOfferTrends />
    </SearchParamsProvider>
  );
};

const LoyaltyOfferTrends = () => {
  const { t } = useTranslation();
  const { open, close, isOpen } = useDrawer();

  const { getSearchResults } = useGetTrendsSearchResults();
  const offersTrends = useSearchQuery(useOffersTrendsQuery, {
    filteredSearchParams,
    getPaging: data => data?.dataGrid?.paging,
    getSearchResults: data =>
      getSearchResults(
        data?.dataGrid?.offers,
        data?.dataGrid?.total,
        'offerId',
      ),
  });

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            offersTrends,
          },
        }}
      >
        <SearchToolbar />
        <Stack>
          <LoyaltyPerformanceHeader open={open} />
        </Stack>
        <Stack gap={2}>
          <LoyaltyOfferTrendsLineChart />
          <TrendsDataGrid
            queryName="offersTrends"
            data-testid="LoyaltyOfferTrends.SearchDataGrid"
            displayInfoHeaderName={t(
              'page.loyaltyPerformanceReport.tabs.loyaltyOfferTrends.grid.offerName.title',
            )}
            maxColumns={getMaxColumns(
              offersTrends.data?.dataGrid?.offers ?? [],
            )}
            isOffer
          />
        </Stack>
      </MultipleSearchQueryProvider>
      <LoyaltyOfferTrendsAPIDetailsDrawer isOpen={isOpen} close={close} />
    </Stack>
  );
};

export default function GatedPage() {
  return (
    <JobsStatusGate>
      <SearchParamsWrapper />
    </JobsStatusGate>
  );
}
